import React, { useEffect } from 'react';

type PropsType = {
  children?: any;
};

function Empty({ children }: PropsType) {
  const init = () => {
  };
  useEffect(init, []);

  return (
    <main id="contents" role="main">
      {children}
    </main>
  );
}

export default Empty;
